module.exports = __webpack_public_path__ + "img/i25.70716bb3.png";